<template>
  <div>
    <div class="ui warning message">
      <p>You have entered an invalid study URL. Please check that your URL follows this format:<p>
      <p><strong>{{ validUrlFormat }}<span class="highlight">study-id</span></strong></p>
      <p>If the issue persists, contact your study organiser for more information.</p></div>
  </div>
</template>

<script>

export default {
  name: 'NotFound',
  computed: {
    validUrlFormat: function () {
      return window.origin + '/'
    }
  }
}

</script>

<style scoped>

.highlight {
  background-color: rgba(0,0,255,0.15);
  padding: 1px;
}

</style>
